/**
 * Retrieves the state from the given coordinates
 * @param lat Latitude
 * @param lng Longitude
 * @returns The complete address
 */
export async function getLocationFromCoordinates(lat: number, lng: number) {
    const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,
    );

    const data = await response.json();

    return data.address;
}
